import { Component, OnInit, ViewChild } from '@angular/core'
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator'
import { MatSort, Sort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { ReportService } from 'src/app/services/report.service'
import { CustomPaginator } from 'src/app/shared/utils/paginator'
import { saveAs } from 'file-saver'
import { DatePipe } from '@angular/common'
import { FormGroup, FormControl } from '@angular/forms'

const CSV_EXTENSION = '.csv'
const CSV_TYPE = 'text/plain;charset=utf-8'

@Component({
  selector: 'app-statistiques',
  templateUrl: './statistiques.component.html',
  styleUrls: ['./statistiques.component.scss'],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: CustomPaginator,
    },
  ]
})
export class StatistiquesComponent implements OnInit {

  dataSourceShared = new MatTableDataSource()
  displayedColumnsShared = ['nameProspect', 'emailProspect', 'socialReason', 'nameSender', 
    'sentAt', 'marketName', 'supportName', 'documentName']

  dataSourceStatistics = new MatTableDataSource()
  displayedColumnsStatistics = ['nbDownload', 'documentName', 'supportName', 'marketName']

  @ViewChild('paginator',{read: MatPaginator}) paginator: any
  @ViewChild('paginatorStatistics',{read: MatPaginator}) paginatorStatistics: any
  @ViewChild(MatSort) sort: any

  range = new FormGroup({
    startDate: new FormControl<Date>(new Date(new Date().getFullYear(), 0, 1)),
    endDate: new FormControl<Date>(new Date(new Date().getFullYear(), 11, 31)),
  })

  partages = []
  statistiques = []
  element = 'Partages'

  max = new Date(9999, 11, 31)
  min = new Date(1900, 0, 1)

  PARTIAL_DATE_REGEX =
    /^((?:0|$)?(?:[1-9]|$)?|(?:[12]|$)?(?:[0-9]|$)?|(?:3|$)?(?:[01]|$)?)(?:\/|$)((?:0|$)?(?:[1-9]|$)?|(?:1|$)?(?:[012]|$)?)(?:\/|$)((?:[0-9]|$){0,4})$/

  constructor (
    public reportService: ReportService, 
    private datePipe: DatePipe) { }

  ngOnInit(): void {
    document.documentElement.style.setProperty('--focus-color', '#E74A3B')
    this.getRange()
    this.getShared()
  }

  getRange() {
    this.range.get('startDate')?.setValue(new Date(new Date().getFullYear(), 0, 1))
    this.range.get('endDate')?.setValue(new Date(new Date().getFullYear(), 11, 31))
  }

  getShared() {
    const startDate = this.datePipe.transform(this.range.get('startDate')?.value, 'yyyy-MM-dd')
    const endDate = this.datePipe.transform(this.range.get('endDate')?.value, 'yyyy-MM-dd')
    this.reportService.getAllReportShared(startDate, endDate).subscribe(
      (reports) => {
        this.partages = reports
        this.dataSourceShared.data = this.partages
        this.dataSourceShared.sort = this.sort
        this.dataSourceShared.paginator = this.paginator

        this.dataSourceShared.filterPredicate = (data: any, filter: string): boolean => {
          return data.nameProspect.toLowerCase().includes(filter) || data.emailProspect.toLowerCase().includes(filter) ||
            data.socialReason.toLowerCase().includes(filter) || data.nameSender.toLowerCase().includes(filter) ||
            data.marketName.toLowerCase().includes(filter) || data.supportName.toLowerCase().includes(filter) || 
            data.documentName.toLowerCase().includes(filter)
        }

        this.sortData({
          active: 'sentAt',
          direction: 'desc'
        }, this.dataSourceShared, this.partages)
      }
    )
  }

  getStatistics() {
    const startDate = this.datePipe.transform(this.range.get('startDate')?.value, 'yyyy-MM-dd')
    const endDate = this.datePipe.transform(this.range.get('endDate')?.value, 'yyyy-MM-dd')
    this.reportService.getAllReportStatistics(startDate, endDate).subscribe(
      (reports) => {
        this.statistiques = reports
        this.dataSourceStatistics.data = this.statistiques
        this.dataSourceStatistics.sort = this.sort
        this.dataSourceStatistics.paginator = this.paginatorStatistics
        
        this.dataSourceStatistics.filterPredicate = (data: any, filter: string): boolean => {
          return data.nbDownload == filter || data.marketName?.toLowerCase().includes(filter) || 
          data.supportName?.toLowerCase().includes(filter) || data.documentName.toLowerCase().includes(filter)
        }
        
        this.sortData({
          active: 'nbDownload',
          direction: 'desc'
        }, this.dataSourceStatistics, this.statistiques)
      }
    )
  }

  onInput(event: InputEvent): void {
    if (event.inputType === 'deleteContentBackward' || !event.data) return

    this.preventLongYear(event)
    this.forceFormat(event)
  }

  preventLongYear(event: any): void {
    const input = event.target
    const inputValue = input?.value

    const newValue =
      inputValue.substring(0, input.selectionStart) +
      event.data +
      inputValue.substring(input.selectionEnd)

    if (event.inputType !== 'deleteContentBackward' && newValue.length > 10) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  forceFormat(event: any): void {
    const input = event.target
    const inputValue = input?.value

    const newValue =
      inputValue.substring(0, input.selectionStart) +
      event.data +
      inputValue.substring(input.selectionEnd)

    if (!this.PARTIAL_DATE_REGEX.test(newValue)) {
      event.preventDefault()
      event.stopPropagation()
      return
    }

    if (newValue.length === 2 || newValue.length === 5) {
      input.value = newValue + '/'
      event.preventDefault()
      event.stopPropagation()
      input.dispatchEvent(new Event('input'))
    }
  }

  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
    //this.range.get('startDate')?.hasError('matStartDateInvalid'))
    //this.range.get('endDate')?.hasError('matEndDateInvalid'))

    const start: any = this.range?.get('startDate')?.value
    const end: any = this.range.get('endDate')?.value
    if (dateRangeStart.value.length === 10 && dateRangeEnd.value.length === 10
        && start < end) {
      if (this.element === 'Partages') {
        this.getShared()
      } else {
        this.getStatistics()
      }
    }
  }

  sortData(sort: Sort, dataSource: any, report: any) {
    const data = report.slice()
    if (!sort.active || sort.direction === '') {
      dataSource.data = data
      return
    }
    // pour chaque données colonne par nom
    dataSource.data = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc'

      switch (sort.active) {
        case 'sentAt':
          const sentAtA = (a.sentAt === null) ? null : new Date(a.sentAt)
          const sentAtB = (b.sentAt === null) ? null : new Date(b.sentAt)
          return this.compareDate(sentAtA, sentAtB, isAsc)
        case 'nameProspect' : 
          return this.compare(a.nameProspect, b.nameProspect, isAsc)
        case 'emailProspect' : 
          return this.compare(a.emailProspect, b.emailProspect, isAsc)
        case 'socialReason' : 
          return this.compare(a.socialReason, b.socialReason, isAsc)
        case 'nameSender' : 
          return this.compare(a.nameSender, b.nameSender, isAsc)
        case 'nbDownload' : 
          return this.compare(a.nbDownload, b.nbDownload, isAsc)
        case 'marketName' : 
          return this.compare(a.marche, b.marche, isAsc)
        case 'supportName' : 
          return this.compare(a.support, b.support, isAsc)
        case 'documentName' : 
          return this.compare(a.document, b.document, isAsc)
        default:
          return this.compare(a, b, isAsc)
      }
    })
  }

  compareDate(a: any, b: any, isAsc: boolean) {
    return (a.getTime() == b.getTime() ? 0 : (a < b ? -1 : 1)) * (isAsc ? 1 : -1)
  }

  compare(a: any, b: any, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1)
  }

  changeTab(evt: any) {
    if (evt.index === 0) {
      this.element = 'Partages'
      document.documentElement.style.setProperty('--focus-color', '#E74A3B')
      this.getRange()
      this.getShared()
    } else {
      this.element = 'Statistiques'
      document.documentElement.style.setProperty('--focus-color', '#8758A1')
      this.getRange()
      this.getStatistics()
    }
  }

  applyFilterShared(event: any) {
    let filterValue = event?.target.value
    this.dataSourceShared.filter = filterValue.trim().toLowerCase()
  }

  applyFilterStatistics(event: any) {
    let filterValue = event?.target.value
    this.dataSourceStatistics.filter = filterValue.trim().toLowerCase()
  }

  exportToCsv(isShared: boolean): any {
    let rows: any = []
    let columns: any = []

    if (isShared) {
      this.dataSourceShared.data.forEach((element: any) => {
        rows.push({
          firstNameProspect: element.firstNameProspect,
          lastNameProspect: element.lastNameProspect, 
          emailProspect: element.emailProspect,
          socialReason: element.socialReason,
          firstNameSender: element.firstNameSender,
          lastNameSender: element.lastNameSender,
          sentAt: this.datePipe.transform(element.sentAt, 'dd/MM/yyyy'),
          marketName: element.marketName,
          supportName: element.supportName,
          documentName: element.documentName
        })
      })
      columns = ['Prénom du prospect', 'Nom du prospect', 'Email du prospect', 'Dénomination sociale', 'Prénom souscripteur Helvetia', 
        'Nom souscripteur Helvetia', 'Date d\'envoi', 'Marché' , 'Support', 'Document']
    } else {
      this.dataSourceStatistics.data.forEach((element: any) => {
        rows.push({
          nbDownload: element.nbDownload,
          documentName: element.documentName,
          marketName: element.marketName,
          supportName: element.supportName,
        })
      })
      columns = ['Nombre de partages', 'Document', 'Marché', 'Support']
    }

    const fileName = 'HELVETIA_' + this.element.toUpperCase() + '_' + this.datePipe.transform(new Date(), 'dd-MM-yyyy')
    const separator = ';'
    const keys = Object.keys(rows[0])
    const BOM = "\uFEFF"
    const csvContent = BOM +
      columns.join(separator) +
      '\n' +
      rows.map((row: any) => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k]
          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""')
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`
          }
          return cell
        }).join(separator)
      }).join('\n')
    this.saveAsFile(csvContent, `${fileName}${CSV_EXTENSION}`, CSV_TYPE)
  }

   saveAsFile(buffer: any, fileName: string, fileType: string): void {
    const data: Blob = new Blob([buffer], { type: fileType })
    saveAs(data, fileName)
  }
}
